import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SyncProgressMutationVariables = Types.Exact<{
  input: Array<Types.SyncProgressInput> | Types.SyncProgressInput;
}>;


export type SyncProgressMutation = { syncProgress: { success?: boolean | null, errorCode?: Types.PerformanceErrorCode | null } };


export const SyncProgressDocument = /*#__PURE__*/ gql`
    mutation syncProgress($input: [SyncProgressInput!]!) {
  syncProgress(input: $input) {
    success
    errorCode
  }
}
    `;

export function useSyncProgressMutation() {
  return Urql.useMutation<SyncProgressMutation, SyncProgressMutationVariables>(SyncProgressDocument);
};